<template>
  <div class="login-container">
    <!-- 添加图标到左上角 -->
    <div class="logo-container">
      <img src="@/assets/组 57.png" alt="Logo" class="logo-image" />
    </div>

    <div class="background">
      <div class="circle-container">
        <div class="circle circle-1"></div>
        <div class="circle circle-2"></div>
        <div class="circle circle-3"></div>
      </div>
    </div>

    <div class="content-wrapper">
      <div class="planet-section">
        <div class="planet-orbit">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 400">
            <defs>
              <linearGradient
                id="orbitGradient"
                x1="0%"
                y1="0%"
                x2="100%"
                y2="0%"
              >
                <stop
                  offset="0%"
                  style="stop-color: #caa87c; stop-opacity: 0.3"
                />
                <stop
                  offset="50%"
                  style="stop-color: #caa87c; stop-opacity: 0.1"
                />
                <stop
                  offset="100%"
                  style="stop-color: #caa87c; stop-opacity: 0.3"
                />
              </linearGradient>
              <linearGradient
                id="orbitGradient1"
                x1="0%"
                y1="0%"
                x2="100%"
                y2="0%"
              >
                <stop
                  offset="0%"
                  style="stop-color: #caa87c; stop-opacity: 0.8"
                />
                <stop
                  offset="50%"
                  style="stop-color: #caa87c; stop-opacity: 0.6"
                />
                <stop
                  offset="100%"
                  style="stop-color: #caa87c; stop-opacity: 0.8"
                />
              </linearGradient>
              <linearGradient
                id="centerGradient"
                x1="100%"
                y1="0%"
                x2="0%"
                y2="100%"
                gradientTransform="rotate(212)"
              >
                <stop
                  offset="0%"
                  style="stop-color: #e8c89e; stop-opacity: 1"
                />
                <stop
                  offset="100%"
                  style="stop-color: #0e1313; stop-opacity: 1"
                />
              </linearGradient>
            </defs>
            <g transform="translate(200, 200)">
              <!-- 外轨道 -->
              <ellipse
                cx="0"
                cy="0"
                rx="160"
                ry="60"
                fill="none"
                stroke="url(#orbitGradient)"
                stroke-width="1"
              >
                <animateTransform
                  attributeName="transform"
                  type="rotate"
                  from="45 0 0"
                  to="405 0 0"
                  dur="35s"
                  repeatCount="indefinite"
                />
              </ellipse>
             

              <!-- 第二轨道 -->
              <ellipse
                cx="0"
                cy="0"
                rx="155"
                ry="60"
                fill="none"
                stroke="url(#orbitGradient)"
                stroke-width="1"
              >
                <animateTransform
                  attributeName="transform"
                  type="rotate"
                  from="120 0 0"
                  to="-240 0 0"
                  dur="30s"
                  repeatCount="indefinite"
                />
              </ellipse>
              <circle cx="155" cy="0" r="6" fill="#caa87c" opacity="0.8">
                <animate
                  attributeName="opacity"
                  values="0.8;1;0.8"
                  dur="2.5s"
                  repeatCount="indefinite"
                />
                <animateTransform
                  attributeName="transform"
                  type="rotate"
                  from="120 0 0"
                  to="-240 0 0"
                  dur="30s"
                  repeatCount="indefinite"
                />
              </circle>
              <circle cx="-155" cy="0" r="7" fill="#caa87c" opacity="0.8">
                <animate
                  attributeName="opacity"
                  values="0.8;1;0.8"
                  dur="2.5s"
                  repeatCount="indefinite"
                />
                <animateTransform
                  attributeName="transform"
                  type="rotate"
                  from="120 0 0"
                  to="-240 0 0"
                  dur="30s"
                  repeatCount="indefinite"
                />
              </circle>
              <!-- 第三轨道 -->
              <ellipse
                cx="0"
                cy="0"
                rx="120"
                ry="60"
                fill="none"
                stroke="url(#orbitGradient1)"
                stroke-width="1"
              >
                <animateTransform
                  attributeName="transform"
                  type="rotate"
                  from="210 0 0"
                  to="570 0 0"
                  dur="25s"
                  repeatCount="indefinite"
                />
              </ellipse>
              <circle cx="120" cy="0" r="5" fill="#caa87c" opacity="0.8">
                <animate
                  attributeName="opacity"
                  values="0.8;1;0.8"
                  dur="3s"
                  repeatCount="indefinite"
                />
                <animateTransform
                  attributeName="transform"
                  type="rotate"
                  from="210 0 0"
                  to="570 0 0"
                  dur="25s"
                  repeatCount="indefinite"
                />
              </circle>

              <!-- 第四轨道 -->
              <ellipse
                cx="10"
                cy="5"
                rx="95"
                ry="60"
                fill="none"
                stroke="url(#orbitGradient1)"
                stroke-width="1"
              >
                <animateTransform
                  attributeName="transform"
                  type="rotate"
                  from="300 0 0"
                  to="-60 0 0"
                  dur="20s"
                  repeatCount="indefinite"
                />
              </ellipse>

              <!-- 中心星球 -->
              <circle cx="0" cy="0" r="50.66" fill="url(#centerGradient)">
                <animate
                  attributeName="opacity"
                  values="0.8;1;0.8"
                  dur="4s"
                  repeatCount="indefinite"
                />
              </circle>
            </g>
          </svg>
        </div>
        <div class="planet-text">
          <h2>智算玄机</h2>
          <p>AI推演·五到修真</p>
        </div>
      </div>
      <div class="login-box">
        <div class="login-header">
          <h1>注册账户</h1>
          <p>解读命理，揭秘未来</p>
        </div>

        <div class="login-form">
          <div class="form-item" style="display: flex; align-item: center">
            <el-input
              v-model="registerForm.email"
              placeholder="请输入邮箱"
            ></el-input>
            <div>
              <el-button class="send-code-button" @click="sendVerificationCode">
                获取验证码
              </el-button>
            </div>
          </div>
          <div class="form-item">
            <el-input
              v-model="registerForm.verificationCode"
              placeholder="邮箱验证码"
            ></el-input>
          </div>
          <div class="form-item">
            <el-input
              v-model="registerForm.password"
              type="password"
              placeholder="邀请码"
            ></el-input>
          </div>
          <div class="form-item">
            <el-input
              v-model="registerForm.username"
              placeholder="显示名称"
            ></el-input>
          </div>
          <div class="form-item">
            <el-input
              v-model="registerForm.username"
              placeholder="密码"
            ></el-input>
          </div>
          <div class="form-item">
            <el-button class="login-button" @click="handleLogin"
              >注册账户</el-button
            >
          </div>
          <div class="form-label" @click="goToLogin">
            <span>返回登录</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script>
export default {
  name: "Login",
  data() {
    return {
      registerForm: {
        username: "",
        password: "",
      },
    };
  },
  methods: {
    handleRegister() {
      if (!this.registerForm.email) {
        this.$message.error("请输入邮箱");
        return;
      }
      if (!this.registerForm.verificationCode) {
        this.$message.error("请输入验证码");
        return;
      }
      if (!this.registerForm.password) {
        this.$message.error("请输入密码");
        return;
      }
      if (!this.registerForm.username) {
        this.$message.error("请输入用户名");
        return;
      }

      // 这里模拟注册成功
      this.$message.success("注册成功");
      // 实际项目中这里会调用API进行注册验证
    },
    goToLogin() {
      this.$router.push({ path: "/login" });
    },
    getRandomStyle() {
      const size = Math.floor(Math.random() * 10) + 5;
      const posX = Math.random() * 100;
      const posY = Math.random() * 100;
      const animDuration = Math.random() * 20 + 10;
      const animDelay = Math.random() * 5;

      return {
        width: `${size}px`,
        height: `${size}px`,
        left: `${posX}%`,
        top: `${posY}%`,
        animationDuration: `${animDuration}s`,
        animationDelay: `${animDelay}s`,
      };
    },
  },
};
</script>
  
  <style lang="scss" scoped>
.login-container {
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  background: #0e1313;
  overflow: hidden;
}

.content-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 100px;
  z-index: 1;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.planet-section {
  text-align: center;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  /* gap: 3rem; */
  max-width: 360px;
}

.planet-orbit {
  width: 300px;
  height: 300px;
  opacity: 0.8;
  display: flex;
  flex-direction: column;
  align-items: center;
  /* transform-style: preserve-3d; */
  /* perspective: 1000px; */
  /* transform: rotateX(20deg); */
}

.planet-text {
  /* margin-top: 30px; */
  color: #ffe8ca;
  text-align: center;

  h2 {
    font-size: 24px;
    font-weight: 400;
    font-family: Kunminghaiouti, Kunminghaiouti;
    margin-bottom: 10px;
    letter-spacing: 2px;
    animation: fadeInUp 0.8s ease-out forwards;
  }

  p {
    font-size: 16px;
    opacity: 0.8;
    font-family: Kunminghaiouti, Kunminghaiouti;
    animation: fadeInUp 0.8s ease-out forwards;
  }
}

.logo-container {
  position: absolute;
  top: 20px;
  left: 20px;
  z-index: 10;
}

.logo-image {
  height: 40px;
  width: auto;
  filter: drop-shadow(0 0 5px rgba(255, 255, 255, 0.3));
}

.background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
}

.circle-container {
  position: absolute;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.circle {
  position: absolute;
  border-radius: 50%;
  background: rgba(255, 0, 0, 0.05);
  box-shadow: 0 0 50px rgba(255, 0, 0, 0.1);
}

.circle-1 {
  width: 600px;
  height: 600px;
  top: -200px;
  right: -200px;
  background: rgba(255, 0, 0, 0.03);
  animation: float 20s infinite ease-in-out;
}

.circle-2 {
  width: 400px;
  height: 400px;
  bottom: -100px;
  left: -100px;
  background: rgba(255, 0, 0, 0.04);
  animation: float 15s infinite ease-in-out reverse;
}

.circle-3 {
  width: 300px;
  height: 300px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(255, 0, 0, 0.02);
  animation: pulse 10s infinite ease-in-out;
}

.particles {
  position: absolute;
  width: 100%;
  height: 100%;
}

.particle {
  position: absolute;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  animation: float-particle 20s infinite linear;
}

.login-box {
  position: relative;
  z-index: 1;
  width: 400px;
}

.login-header {
  text-align: center;
  margin-bottom: 30px;

  h1 {
    color: #ffe8ca;
    font-size: 28px;
    margin-bottom: 10px;
    font-weight: 400;
    font-family: Kunminghaiouti, Kunminghaiouti;
    letter-spacing: 2px;
    text-shadow: 0 0 10px rgba(255, 255, 255, 0.3);
    animation: fadeInUp 0.8s ease-out forwards;
  }

  p {
    color: #ffe8ca;
    font-size: 20px;
    font-weight: 400;
    font-family: Kunminghaiouti, Kunminghaiouti;
    animation: fadeInUp 0.8s ease-out forwards;
  }
}

.login-form {
  .form-item {
    margin-bottom: 25px;
    background: transparent;
    border: none;
  }

  .form-label {
    font-family: Source Han Serif SC, Source Han Serif SC;
    font-weight: 400;
    font-size: 16px;
    color: #ffe8ca;
    letter-spacing: 1px;
    text-align: center;
    cursor: pointer;
  }

  ::v-deep .el-input__inner {
    background: transparent;
    border: 1px solid #caa87c;
    color: #fff;
    height: 50px;
    border-radius: 4px;
    font-family: Source Han Serif SC, Source Han Serif SC;
    font-weight: 400;
    font-size: 16px;
    color: #ffe8ca;
    &::placeholder {
      color: rgba(255, 255, 255, 0.5);
    }
  }

  ::v-deep .el-input__prefix {
    display: none;
  }
  .send-code-button {
    height: 100%;
    background: #caa87c;
    border: 1px solid #caa87c;
    font-family: Source Han Serif SC, Source Han Serif SC;
    font-weight: 400;
    font-size: 16px;
    color: #161b1a;
    margin-left: 10px;
  }
  .login-button {
    width: 100%;
    height: 44px;
    background: #caa87c;
    border: 1px solid #caa87c;
    font-family: Source Han Serif SC, Source Han Serif SC;
    font-weight: 400;
    font-size: 16px;
    color: #161b1a;
    letter-spacing: 2px;
    margin-top: 20px;
    border-radius: 22px;
    border-color: none;
    &:hover,
    &:focus {
      background: #d6b88c;
      box-shadow: 0 0 15px rgba(202, 168, 124, 0.5);
    }
  }
}
@keyframes fadeInUp {
  0% {
    opacity: 0;
    transform: translateY(20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes float {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-30px);
  }
}

@keyframes pulse {
  0%,
  100% {
    transform: translate(-50%, -50%) scale(1);
    opacity: 0.5;
  }
  50% {
    transform: translate(-50%, -50%) scale(1.2);
    opacity: 0.3;
  }
}

@keyframes float-particle {
  0% {
    transform: translateY(0) rotate(0deg);
    opacity: 0;
  }
  10% {
    opacity: 1;
  }
  90% {
    opacity: 1;
  }
  100% {
    transform: translateY(-100vh) rotate(360deg);
    opacity: 0;
  }
}
</style>